import { render, staticRenderFns } from "./OpportunitiesKanban.vue?vue&type=template&id=5125cc7a&scoped=true&"
import script from "./OpportunitiesKanban.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesKanban.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesKanban.vue?vue&type=style&index=0&id=5125cc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125cc7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSelect,VSpacer,VTextField,VToolbar})
